const BTN_BASE =
  "px-3 py-1.5 text-xs font-accent font-semibold tracking-wide border transition-colors";

export const DraftNote = ({ lang }) =>
  lang === "cy" ? (
    <p
      data-testid="welsh-draft-note"
      className="mt-3 text-[11px] font-accent text-ink-muted bg-linen-alt border-l-2 border-ember px-3 py-2 leading-relaxed"
    >
      <strong className="text-ink">Cyfieithiad drafft.</strong> Mae&rsquo;r cyfieithiad
      Cymraeg hwn yn aros am wiriad gan siaradwr Cymraeg — os gwelwch wall,
      rhowch wybod i ni. <em>This is a draft translation awaiting review by a
      Welsh speaker.</em>
    </p>
  ) : null;

export default function LangToggle({ lang, setLang }) {
  return (
    <div className="print:hidden inline-flex items-center" role="group" aria-label="Language">
      <button
        type="button"
        data-testid="lang-toggle-en"
        onClick={() => setLang("en")}
        className={`${BTN_BASE} ${
          lang === "en"
            ? "bg-ink text-linen border-ink"
            : "bg-transparent text-ink-muted border-rule hover:border-ink hover:text-ink"
        }`}
      >
        English
      </button>
      <button
        type="button"
        data-testid="lang-toggle-cy"
        onClick={() => setLang("cy")}
        className={`${BTN_BASE} -ml-px ${
          lang === "cy"
            ? "bg-ink text-linen border-ink"
            : "bg-transparent text-ink-muted border-rule hover:border-ink hover:text-ink"
        }`}
      >
        Cymraeg
      </button>
    </div>
  );
}
